module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6461/assets/images/data-studio.jpg"